/* Publish by EComposer at 2026-10-31 04:31:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ws7thbhnbga"]=  window.__ectimmers["ecom-ws7thbhnbga"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ws7thbhnbga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ws7thbhnbga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxcgyleqo0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxcgyleqo0a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85yxqvzvgzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85yxqvzvgzn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r7c004gk9lc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r7c004gk9lc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-327ywrhlld5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-327ywrhlld5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ha08alj5gu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ha08alj5gu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljfwejcoclj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljfwejcoclj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kdz0izewaup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdz0izewaup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-97os543w71n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97os543w71n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qivlnkqr4on').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qivlnkqr4on', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zh2a5j6vqxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zh2a5j6vqxh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48eh3m7wl3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48eh3m7wl3h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3b7dgr227s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3b7dgr227s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rozh1m3w2mo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rozh1m3w2mo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-muy8h4jkl8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-muy8h4jkl8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nr6po0htf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nr6po0htf4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ozzcq3lpb3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ozzcq3lpb3f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0bf72wqf4rh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0bf72wqf4rh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zliqa1buaon').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zliqa1buaon', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sh68vfgebnb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sh68vfgebnb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6362z0j8oeu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6362z0j8oeu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6yhbha45263').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6yhbha45263', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-egskj92b7d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-egskj92b7d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7aa9uv7kg8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7aa9uv7kg8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d9b10pa077').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9b10pa077', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zeal3cujdx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zeal3cujdx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-elfr8kd6gu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-elfr8kd6gu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zsh9140k9ii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zsh9140k9ii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dwu5pw4a3nr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dwu5pw4a3nr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k3291tmh35j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k3291tmh35j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fc1vnp4polb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fc1vnp4polb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ep3lsbqtmcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ep3lsbqtmcr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-67ui4bnmrtj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67ui4bnmrtj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fajf5gws8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fajf5gws8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-de37rc5orpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-de37rc5orpb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yumh1tn4mzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yumh1tn4mzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1dw0qj4htgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1dw0qj4htgo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcj7ptnrsid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcj7ptnrsid', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfclfozr04n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfclfozr04n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9fb0u7f4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9fb0u7f4j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-393bai9nc01').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-393bai9nc01', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gvfdp5j3knb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gvfdp5j3knb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gdjan80x75a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gdjan80x75a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phf55t7mvkb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phf55t7mvkb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kyse91slyvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyse91slyvp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqpho0mdllk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqpho0mdllk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjqwpakxejj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjqwpakxejj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyhod09tf35').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyhod09tf35', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfolx3tyqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfolx3tyqi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1pjvn43wq07').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1pjvn43wq07', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g2rtvn95hf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g2rtvn95hf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0cypcjsusqp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0cypcjsusqp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gulvcrg666').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gulvcrg666', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pmwjzou7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pmwjzou7s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tbnrhwsc5fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tbnrhwsc5fk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-grj8yq3wmyi"]=  window.__ectimmers["ecom-grj8yq3wmyi"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-grj8yq3wmyi"]["3i7uvjz7p"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-grj8yq3wmyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grj8yq3wmyi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i9lic7711x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i9lic7711x', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d2xiewgz2w4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d2xiewgz2w4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jgeqv794nn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jgeqv794nn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-unkgaetbxyj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unkgaetbxyj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mijhqcx1508').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mijhqcx1508', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-funh8b2d4ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-funh8b2d4ei', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phpa8rnl54n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phpa8rnl54n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0wnmdcg4oite').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0wnmdcg4oite', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6avfss8za7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6avfss8za7g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1xgb6kscmq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1xgb6kscmq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-funob2szckw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-funob2szckw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nzbn9prr7t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nzbn9prr7t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sp501zspxuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sp501zspxuo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bya2bdn3ed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bya2bdn3ed', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qr7fdrsapls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qr7fdrsapls', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn2hwm11w5w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn2hwm11w5w', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ciytfdd1gb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ciytfdd1gb8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzw853h98ql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzw853h98ql', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f0k6tbzgr8v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f0k6tbzgr8v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4erp9uz26yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4erp9uz26yd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oyufjij2hfa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oyufjij2hfa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mqzdgei153').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mqzdgei153', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8khf856l4re').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8khf856l4re', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hlluj6duasl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hlluj6duasl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wpwqxfjsqub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wpwqxfjsqub', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arn02shjw6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arn02shjw6d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fq9myza7ci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fq9myza7ci', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7bv1v440uaw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7bv1v440uaw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1zqam7bvful').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1zqam7bvful', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vimh42vdbu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vimh42vdbu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhcio73hnr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhcio73hnr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xmf5guezorq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmf5guezorq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ixyb13rsnno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ixyb13rsnno', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e0sd2cve0rp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e0sd2cve0rp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96q4vpopae5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96q4vpopae5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gtzph67f59h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gtzph67f59h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ajxkgwmzi3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ajxkgwmzi3b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7f7qvpxb3t5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7f7qvpxb3t5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xq5232eirg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xq5232eirg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2wrlbzjmwlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2wrlbzjmwlr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uxxi7c1xbec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxxi7c1xbec', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8q25h133dbq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8q25h133dbq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55r4e3lgpia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55r4e3lgpia', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wo76h93kir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wo76h93kir', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vmbzp5lwxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vmbzp5lwxn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e6sq29i8yj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e6sq29i8yj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c8v2a52ef9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8v2a52ef9b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4efy6zndfx4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4efy6zndfx4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tokzzdpq2y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tokzzdpq2y', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89oiiu0wjnu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89oiiu0wjnu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilyfoalvvrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilyfoalvvrl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fg00hj67omi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fg00hj67omi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u89rx5wr2un').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u89rx5wr2un', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xz3iwk1wm98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xz3iwk1wm98', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbzhs58qt1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbzhs58qt1k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6astqy0q6r5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6astqy0q6r5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pilmk6losg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pilmk6losg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6uf44x2z7vj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6uf44x2z7vj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xc3d5jkf4qk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xc3d5jkf4qk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9g4xhiyzxku').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9g4xhiyzxku', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23n5j8fgwnii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23n5j8fgwnii', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yy4l1ebz43').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yy4l1ebz43', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xv1tr16kmpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xv1tr16kmpo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhkj0xbdjuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhkj0xbdjuo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cor517p5mc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cor517p5mc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c10fvlsz5ps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c10fvlsz5ps', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7pijqqkromu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7pijqqkromu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwzul4kfpgc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwzul4kfpgc', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uu3wohh378"]=  window.__ectimmers["ecom-uu3wohh378"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-uu3wohh378"]["jfa2fzrvr"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-uu3wohh378').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uu3wohh378', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eyp7ddxa7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eyp7ddxa7m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70dw1ubp5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70dw1ubp5p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vziovqxtf3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vziovqxtf3', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-is61xkkayoo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-is61xkkayoo', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf6gpo8ohjd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf6gpo8ohjd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2auhnm9vubi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2auhnm9vubi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8p87f3zzx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8p87f3zzx', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7wy2oq2bkx3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7wy2oq2bkx3', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgorbrdrmx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgorbrdrmx', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4hxikngj82j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hxikngj82j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ggukhgtldth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ggukhgtldth', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmc0zqhe1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmc0zqhe1r', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjfwqdt9yv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjfwqdt9yv', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uw3rr5tnbsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uw3rr5tnbsa', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-njliptsm1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-njliptsm1p', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jc39qcry54').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jc39qcry54', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jzz48gbbn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jzz48gbbn9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwyujdlbgp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwyujdlbgp', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kv8966olov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kv8966olov', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbxihidbymi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbxihidbymi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b5nhm6ne9uh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b5nhm6ne9uh', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-px73ioemqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-px73ioemqd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i1jgc9m9r1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i1jgc9m9r1', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vngs8ilkico').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vngs8ilkico', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8hh7tshd8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8hh7tshd8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qz0fn365lw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qz0fn365lw', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnsocpjjkii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnsocpjjkii', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8dt8rikobwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8dt8rikobwc', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r4nfbnz81m9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r4nfbnz81m9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sn7sbwkj2ig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sn7sbwkj2ig', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5um92avm1ll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5um92avm1ll', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sj2nkkyzym8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sj2nkkyzym8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rynyvl6mi4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rynyvl6mi4l', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nbsftznbh4"]=  window.__ectimmers["ecom-nbsftznbh4"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,n=this.settings.autoplay,o=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const p=t.querySelector(".ecom-video-poster");let m;m=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b(I){let j={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,j).observe(I)}function y(I,j){let M={handleMouseenter:D,handleMouseleave:T,handleEnded:F};function D(){I.readyState>=c&&I.pause()}function T(){I.readyState>=c&&I.play()}function F(){v(I,M)}if(r){I.addEventListener("mouseenter",D),I.addEventListener("mouseleave",T);let H=t.querySelector(".ecom-video_link-extra");H&&H.href&&(H.addEventListener("mouseenter",D),H.addEventListener("mouseleave",T)),j||I.addEventListener("ended",F)}}function v(I,j){if(j){const{handleMouseenter:M,handleMouseleave:D,handleEnded:T}=j;let F=t.querySelector(".ecom-video_link-extra");I.removeEventListener("mouseenter",M),I.removeEventListener("mouseleave",D),I.removeEventListener("ended",T),F&&F.href&&(F.removeEventListener("mouseenter",M),F.removeEventListener("mouseleave",D))}}function w(I,j){I.forEach(function(M){if(M.isIntersecting){const D=M.target.querySelector("video source"),T=M.target.querySelector("video"),F=M.target.querySelector("iframe");if(T&&D&&(D.src=D.dataset.source,T.load(),T.addEventListener("loadeddata",function(){n&&T.play()})),F){let H=F.dataset.srcVideo;F.setAttribute("src",H)}j.unobserve(M.target)}})}let S=t.querySelector(".ecom_video"),C=t.querySelector(".ecom_iframe");a&&S&&S.addEventListener("click",()=>{S.readyState>=c&&(S.paused?S.play():S.pause())}),n&&(d&&d.classList.remove("ecom-overlay"),m&&(m.style.display="none"),p&&(p.style.display="none")),S&&!i&&S.addEventListener("ended",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&S)p&&(p.style.display="none"),S.autoplay=!0,S.play(),d.classList.remove("ecom-overlay"),m.style.display="none";else if(C){let I=C.getAttribute("src");I.includes("autoplay=0")?I=I.replace("autoplay=0","autoplay=1"):I=I+"&autoplay=1",C.setAttribute("src",I),l?setTimeout(()=>{I=I.replace("autoplay=1","autoplay=0"),C.setAttribute("src",I)},100):(p&&(p.style.display="none"),d.classList.remove("ecom-overlay"),m.style.display="none")}}),S&&(e&&!p&&y(S,i),p&&p.addEventListener("click",function(){p.style.display="none",S.play(),e&&y(S,i)}),r||S.addEventListener("pause",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),!s&&d&&S.addEventListener("click",function(){S.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(I){I.dataset.ecTrackingId&&I.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:I.id,tracking_id:I.dataset.ecTrackingId})},{once:!0})});const x=t.querySelector("[ecom-modal]"),$=function(I){if(window.EComModal)return I();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&I()});return}let j=0;const M= window.__ectimmers["ecom-nbsftznbh4"]["p1d6ff6s6"] = setInterval(function(){window.EComModal?(clearInterval(M),I()):++j>=300&&clearInterval(M)},50)},E=this.id;x&&this.settings.image_overlay&&l&&$(function(){const I=x.dataset.width,j=x.dataset.height;var M=E;new window.EComModal(x,{cssClass:[M,"ecom-core","ecom-core-simulator"],onOpen:function(){var D=document.querySelector(".ecom-modal."+M);if(D){const T=D.querySelector(".ecom-modal-box__content");T.classList.add("ecom-element_video-iframe");const F={width:I,height:j};Object.assign(T.style,F)}},onClose:function(){var D=document.querySelector(".ecom-modal."+M);if(D){const T=D.querySelector(".ecom-element_video-iframe iframe");T&&(T.src="")}}})})

                    });
                    
                        document.querySelectorAll('.ecom-nbsftznbh4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nbsftznbh4', settings: {"autoplay":false,"player_controls":true,"click_to_play_pause":false,"source":"youtube"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}